import apiClient from '../apiClient';
import { GET_SUPPLIER_LIST_URL } from '../apiUrl';

const getSupplierListApi = supplierType => {
  return apiClient.get(GET_SUPPLIER_LIST_URL(supplierType));
};

export default getSupplierListApi;
